export enum OrderItemProrateTypeEnum {
  MoneyBack = 1,
  ExtendProduct = 2,
  AddProduct = 3,
}
